var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.02 27.71v-1.74c0-3.47-2.08-4.19-4.36-3.78l-19.1 3.45c-2.29.41-3.97 2.47-3.97 4.87v4.44c0 1.62-1.13 3.01-2.68 3.29l-.34.06c-1.34.24-2.33 1.44-2.33 2.85l-.02 74.35c0 1.47.61 1.33 1.07 1.21l93.87-22.16c1.34-.24 2.33-1.44 2.33-2.85V25.13c0-1.79-1.56-3.15-3.27-2.85l-56.31 9.69c-2.55.45-4.89-.51-4.89-4.26z",
    fill: "#f3ab47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.4 91.44l19.96-43.24c.36-.78.43-1.69.05-2.46c-.46-.94-1.41-1.51-2.94-1.23L64.2 54.13c-2.62.45-3.49.94-4.75 5.29s-1.86 9.38-5.64 9.79l-20.96 3.53c-3.93.72-5.58 4.88-5.58 4.88L5.1 116.76l94.5-22.23c1.35-.23 2.88-1.49 3.8-3.09z",
    fill: "#ffe36c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.47 45.56l-54.85 9.13c-3.6.69-4.44 1.52-5.51 5.42c-1.2 4.37-2.52 9.75-6.3 10.16L32.85 73.8",
    fill: "none",
    stroke: "#fff9c4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.1fb013be9d1fca855f41950d90138beb.svg";
export { ForwardRef as ReactComponent };